import ConfirmModal from '@/components/ConfirmModal';
import { Link } from '@/components/primitives/Link';
import { tenantSelector } from '@/features/configuration/configurationSelector';
import { cancelBookingLoadingSelector } from '@/features/loading/loadingSelectors';
import {
  deletePurchaseFlowBooking,
  resetPurchase,
} from '@/features/purchase/purchaseActions';
import { purchaseFlowBookingSelector } from '@/features/purchase/purchaseSelectors';
import { TransText } from '@/i18n/trans/text';
import { persistor } from '@/store';
import { useDispatch, useSelector } from '@/store/utils';
import { getTenantConfiguration } from '@/utils/tenant';
import { Icons, Typography } from '@fleet/webshop-ui';
import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

const IrishRailLogo = () => (
  <img src="/irishrail_logo.jpg" alt="Irish Rail" className="h-16 w-auto" />
);

const Logo = () => {
  const dispatch = useDispatch();
  const selectedTenant = useSelector(tenantSelector);
  const isCancellingBooking = useSelector(cancelBookingLoadingSelector);
  const TenantIcon =
    selectedTenant.value === 'irishrail'
      ? IrishRailLogo
      : Icons[selectedTenant.value];
  const configuration = getTenantConfiguration(selectedTenant.value);
  const location = useLocation();
  const userIsInCheckout = location.pathname === '/purchase/checkout';
  const booking = useSelector(purchaseFlowBookingSelector);

  const handleRedirectionToConfiguredUrl = useCallback(async () => {
    await dispatch(deletePurchaseFlowBooking(booking!.id!)).unwrap();
    dispatch(resetPurchase());
    void persistor.purge();
    window.location.assign(configuration!.webPageUrl!);
  }, [booking, configuration, dispatch]);

  if (!configuration?.webPageUrl) {
    return <TenantIcon />;
  }

  if (configuration.webPageUrl && userIsInCheckout) {
    return (
      <ConfirmModal
        title={<TransText i18nKey="cancelPurchase" />}
        description={
          <Typography variant="paragraph">
            <TransText i18nKey="areYouSureYouWantToCancelThePurchase" />
          </Typography>
        }
        cancelLabel="dismiss"
        confirmLabel="confirm"
        onConfirm={handleRedirectionToConfiguredUrl}
        isConfirmLoading={isCancellingBooking}
      >
        <div className="cursor-pointer text-dark hover:text-primary-dark focus-visible:outline-tint">
          <TenantIcon />
        </div>
      </ConfirmModal>
    );
  }

  return (
    <Link to={configuration?.webPageUrl} aria-label="Hero">
      <TenantIcon />
    </Link>
  );
};

export default Logo;
